import React, { useState, useEffect, useRef } from 'react';
import { HiOutlineChatAlt2 } from 'react-icons/hi';
import {
  BsFillEyeFill,
  BsFillEyeSlashFill,
  BsFillCheckCircleFill,
} from 'react-icons/bs';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { Formik, Form as FormMilk } from 'formik';
import * as Yup from 'yup';

import { Container, Row, Form, Button, Image, Col } from 'react-bootstrap';
import imagemLogoBackground from '../assets/logo/backgroundLogin.svg';
import imagemLogo from '../assets/logo/logoLiveChat.svg';

import { useAuth } from '../hooks/auth';
import { useToast } from '../hooks/toast';

import { userStatus } from '../enums/userStatus';
import { colorStatus } from '../constant/constant';

import Select from '../components/Select/Select';

const SignIn: React.FC = () => {
  const { signIn } = useAuth();
  const { addToast } = useToast();
  const navigate = useNavigate();
  const [loginUserStatus, setLoginUserStatus] = useState<userStatus>(1);
  const [searchParams] = useSearchParams();
  const refButtonStatus = useRef<HTMLButtonElement>(null);
  const [showPassword, setShowPassword] = useState(false);

  const [showStatus, setShowStatus] = useState(false);

  const validationSchema = Yup.object().shape({
    user: Yup.string().required('O usuário é obrigatório'),
    password: Yup.string().required('A senha é obrigatória'),
  });

  useEffect(() => {
    const linkEmpresa = localStorage.getItem('@LiveChat:linkEmpresa');

    const link = searchParams.get('emp');
    if (linkEmpresa !== null && link === null) {
      window.history.pushState(
        'data',
        'titulo',
        `${window.location.href}?emp=${linkEmpresa}`
      );
    }
  }, []);

  const estiloBotao = {
    background: '#fff',
    borderColor: '#007bff',
    borderRadius: '10px',
    color: '#6a6969',
    top: 0,
    right: 0,
    padding: '0 0.4rem',
    margin: '0 0.66rem',
  };

  return (
    <div className="container-fluid vh-100">
      <div className="row col-12 h-100">
        <section className="col-6 h-100 d-flex align-items-center justify-content-center">
          <div className="col-10 d-flex flex-column align-items-end justify-content-center p-1">
            <Image src={imagemLogo} alt="logo" />
            <h1 className="fw-bold mt-3 text-black">CS Live - Chat</h1>
          </div>

          <div className="col-1 bg-dark" />
        </section>
        <section className="col-6 d-flex align-items-center">
          <Container>
            <Row>
              <Col className="col-6 col-xxl-5" style={{ width: '26.5rem' }}>
                <h1
                  className="ps-2 align-items-end justify-content-center fw-bold"
                  style={{ fontSize: '2.25rem' }}
                >
                  Login
                </h1>
                <Formik
                  initialValues={{ user: '', password: '' }}
                  validationSchema={validationSchema}
                  onSubmit={async (values, { setSubmitting }) => {
                    try {
                      setSubmitting(true);
                      const status = await signIn(values);
                      setSubmitting(false);
                      if (status === 200) {
                        navigate('/');
                      } else {
                        addToast({
                          type: 'error',
                          title: 'Erro na autenticação',
                          description: 'Usuário ou senha incorreto.',
                        });
                      }
                    } catch (error) {
                      addToast({
                        type: 'error',
                        title: 'Erro na autenticação',
                        description:
                          'Ocorreu um erro ao fazer login, cheque as credenciais.',
                      });
                    }
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    isSubmitting,
                  }) => (
                    <FormMilk>
                      <Form.Group controlId="email">
                        <Form.Label
                          className="fw-bold"
                          style={{ fontSize: '1.5rem' }}
                        >
                          Usuário
                        </Form.Label>
                        <Form.Control
                          type="user"
                          placeholder="Informe o usuário"
                          name="user"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.user}
                          className={`w-100 inputBox ${
                            touched.user && errors.user ? 'is-invalid' : ''
                          }`}
                          style={{ fontSize: '1.25rem' }}
                        />
                        {touched.user && errors.user ? (
                          <div className="mt-1 invalid-feedback">
                            {errors.user}
                          </div>
                        ) : null}
                      </Form.Group>
                      <Form.Group controlId="password" className="mt-2">
                        <Form.Label
                          className="fw-bold"
                          style={{ fontSize: '1.5rem' }}
                        >
                          Password
                        </Form.Label>
                        <div className="d-flex position-relative">
                          <Form.Control
                            type={showPassword ? 'text' : 'password'}
                            placeholder="Password"
                            name="password"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.password}
                            className={`w-100 form-control position-relative inputBox ${
                              touched.password && errors.password
                                ? 'is-invalid'
                                : ''
                            } `}
                            style={{ fontSize: '1.25rem' }}
                          />

                          <Button
                            className="mt-2 border-0 shadow-none position-absolute"
                            variant=""
                            style={estiloBotao}
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            {showPassword ? (
                              <BsFillEyeSlashFill />
                            ) : (
                              <BsFillEyeFill />
                            )}
                          </Button>
                        </div>
                        {touched.password && errors.password ? (
                          <div className="mt-1 invalid-feedback d-block">
                            {errors.password}
                          </div>
                        ) : null}

                        <div className="d-flex align-items-center justify-content-around mt-2">
                          <div className="d-flex me-1 inputBox bg-white">
                            <Select
                              loginUserStatus={loginUserStatus}
                              setLoginUserStatus={setLoginUserStatus}
                            />
                          </div>

                          <Button
                            variant="primary"
                            type="submit"
                            className="ms-1"
                            style={{
                              width: '15rem',
                              height: '2.4rem',
                              fontSize: '1.25rem',
                            }}
                            disabled={isSubmitting}
                          >
                            Entrar
                          </Button>
                        </div>
                      </Form.Group>
                    </FormMilk>
                  )}
                </Formik>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </div>
  );
};

export default SignIn;
